/**
 * Member Insights Translations Module (Japanese)
 * 
 * Contains: Member Profile, Demographics, Motivations, Experience, Alumni Network
 * Streamlined version - matches English structure
 * 
 * @module members
 * @language ja
 */

export const members = {
  memberInsightsPage: {
    pageSubtitle: "全地域3,790人以上の回答者による人口統計、モチベーション、体験調査結果"
  },
  membershipExperience: {
    title: "会員体験調査",
    subtitle: "すべてのタッチポイントでの会員満足度とエンゲージメントの理解",
    overallSatisfaction: "総合満足度",
    programQuality: "プログラムの質",
    networkingOpportunities: "ネットワーキング機会",
    satisfactionMetrics: "満足度メトリクス",
    npsBreakdown: "NPSブレークダウン",
    benefitsValue: "ベネフィット価値",
    membershipJourney: "会員ジャーニー",
    general: "一般満足度",
    eventQuality: "イベントの質",
    networking: "ネットワーキング",
    personalDevelopment: "個人開発",
    leadership: "リーダーシップ",
    community: "コミュニティエンゲージメント",
    target: "目標",
    npsScore: "NPSスコア",
    excellent: "優秀",
    retentionRate: "継続率",
    recommendation: "推奨したい",
    promoters: "推奨者",
    neutrals: "中立",
    detractors: "批判者",
    professionalNetworking: "プロフェッショナルネットワーキング",
    leadershipDevelopment: "リーダーシップ開発",
    personalGrowth: "個人成長",
    careerOpportunities: "キャリア機会",
    communicationSkills: "コミュニケーションスキル",
    socialResponsibility: "社会的責任",
    businessKnowledge: "ビジネス知識",
    internationalConnections: "国際的つながり",
    high: "高",
    medium: "中",
    low: "低",
    firstYear: "1年目",
    secondThirdYear: "2-3年目",
    fourthFifthYear: "4-5年目",
    fivePlusYears: "5年以上",
    satisfaction: "満足度",
    engagement: "エンゲージメント",
    retention: "継続"
  },
  occupation: {
    title: "職業と業界分析",
    subtitle: "JCI会員の詳細なプロフェッショナルプロファイル",
    leadership: "リーダーシップ",
    entrepreneurs: "起業家",
    mainSectors: "主要セクター",
    careerSatisfaction: "キャリア満足度",
    goalOriented: "目標志向",
    industryDistribution: "業界分布",
    occupationalLevels: "職業レベル",
    hierarchicalLevels: "階層的",
    entrepreneurialProfile: "起業家プロファイル",
    careerStages: "キャリアステージ",
    professionalGoals: "プロフェッショナル目標",
    salaryRanges: "給与範囲",
    technology: "テクノロジー",
    financialServices: "金融サービス",
    consulting: "コンサルティング",
    ecommerce: "Eコマース",
    health: "ヘルス",
    education: "教育",
    marketing: "マーケティング",
    manufacturing: "製造",
    realEstate: "不動産",
    others: "その他"
  },
  memberProfile: {
    title: "JCI会員プロファイル",
    surveyDescription: "2025年会員体験調査 • 全地域3,790人の回答者",
    averageAge: "平均年齢",
    ageRange: "範囲：18-40歳",
    universityEducated: "大学教育",
    degreesHeldPursuing: "取得または取得中の学位",
    entrepreneurs: "起業家",
    selfEmployedMembers: "自営業会員",
    surveyRespondents: "調査回答者",
    allJCIAreas: "全4つのJCIエリア",
    ageGroupAnalysis: "年齢グループ分析",
    coreAgeGroup: "コア28-40歳",
    ofMembers: "の会員",
    challenges: "課題",
    strengths: "強み",
    averageAgeByRegion: "地域別平均年齢",
    youngest: "最年少",
    oldest: "最年長",
    membershipTenureAnalysis: "会員期間分析",
    newMembers: "新規会員",
    strongOnboarding: "強力なオンボーディングパイプライン",
    buildingFoundation: "基盤構築",
    developingSkills: "スキルとネットワークを開発中",
    activeContributors: "アクティブ貢献者",
    peakEngagement: "ピークエンゲージメント期間",
    experiencedLeaders: "経験豊富なリーダー",
    mentorshipRoles: "メンターシップとリーダーシップの役割",
    coreLeaders: "コアリーダー",
    institutionalKnowledge: "組織の知識",
    years: "年",
    freshEnergy: "新鮮なエネルギー",
    alumniNetwork: "アラムナイネットワーク",
    generationalContinuity: "メンターシップを通じた世代間の継続性",
    alumniClubs: "アラムナイクラブ",
    nations: "国",
    avgStay: "平均滞在",
    alumniTransition: "40歳以上はアラムナイに移行",
    insight: "インサイト",
    leadershipProgression: "リーダーシップ昇進",
    localChapterLeaders: "ローカル組織リーダー",
    foundationOfJCI: "JCIの基盤",
    nationalDirectors: "ナショナルディレクター",
    regionalLeadership: "地域リーダーシップ",
    jciSenators: "JCIセネター",
    distinguishedAlumni: "著名なアラムナイ",
    internationalOfficers: "インターナショナルオフィサー",
    globalLeadership: "グローバルリーダーシップコホート",
    majority: "大多数",
    significant: "重要",
    growing: "成長中",
    educationalAttainment: "教育達成度",
    employmentDistribution: "雇用分布",
    bachelorsDegree: "学士号",
    mastersDegree: "修士号",
    mastersEnrolled: "修士（在籍中）",
    phdPursuing: "博士課程",
    technicalVocational: "技術/職業",
    fullTimeEmployed: "フルタイム雇用",
    entrepreneurSelfEmployed: "起業家/自営業",
    student: "学生",
    other: "その他",
    universityDegrees: "JCI会員の97%以上が大学学位を取得または取得中",
    entrepreneursInsight: "31%が起業家または自営業",
    industryDiversity: "業界の多様性",
    primarySectors: "JCI会員が代表する主要セクター",
    education: "教育",
    technology: "テクノロジー",
    finance: "ファイナンス",
    healthcare: "ヘルスケア",
    nonprofit: "非営利",
    government: "政府",
    manufacturing: "製造",
    services: "サービス",
    careerEntry: "キャリアエントリー",
    financialIndependence: "経済的独立",
    leadershipPositions: "リーダーシップポジション",
    workLifeBalance: "ワークライフバランス",
    communityImpact: "コミュニティインパクト",
    ageGroupChallenges: "年齢グループの課題",
    ageGroupStrengths: "年齢グループの強み",
    familyResponsibilities: "家族の責任",
    careerGrowth: "キャリア成長の要求",
    workPressure: "仕事のプレッシャー",
    experience: "経験",
    leadership: "リーダーシップ",
    focus: "フォーカス",
    workLifeIntegration: "ワークライフ統合",
    leadershipDemands: "リーダーシップの要求",
    mentorship: "メンターシップスキル",
    strategicThinking: "戦略的思考",
    networkBuilding: "ネットワーク構築",
    educationBalance: "教育バランス",
    digitalNative: "デジタルネイティブ",
    freshPerspective: "新鮮な視点",
    enthusiasm: "熱意",
    careerDevelopment: "キャリア開発",
    financialPressure: "経済的プレッシャー",
    networking: "ネットワーキング",
    ambition: "野心",
    innovation: "イノベーション",
    timeForMentoring: "メンタリングの時間",
    industryExpertise: "業界の専門知識"
  },
  memberMotivations: {
    title: "会員のモチベーションと価値観",
    subtitle: "JCI会員のエンゲージメントを促進するもの",
    whyJoinJCI: "会員がJCIに参加する理由",
    coreMotivations: "コアモチベーション",
    personalGrowth: "個人成長",
    personalGrowthDesc: "自己開発とスキル構築",
    leadershipDevelopment: "リーダーシップ開発",
    leadershipDesc: "リーダーシップスキルと経験",
    networking: "ネットワーキング",
    networkingDesc: "プロフェッショナルおよびソーシャルコネクション",
    communityImpact: "コミュニティインパクト",
    communityDesc: "地域で変化を起こす",
    careerOpportunities: "キャリア機会",
    careerDesc: "プロフェッショナルな進歩",
    businessDevelopment: "ビジネス開発",
    businessDesc: "ビジネスまたはキャリアを成長させる",
    internationalExposure: "国際的露出",
    internationalDesc: "グローバルなつながりと旅行",
    socialBelonging: "社会的所属",
    socialDesc: "友情とコミュニティ",
    ofRespondents: "の回答者",
    topMotivation: "トップモチベーション",
    benefitsRanking: "ベネフィットランキング",
    benefitsCitation: "会員が挙げるトップベネフィット（重要度順）",
    leadershipTraining: "リーダーシップトレーニング",
    professionalNetwork: "プロフェッショナルネットワーク",
    personalDevelopment: "個人開発",
    internationalConnections: "国際的つながり",
    communityService: "コミュニティサービス",
    businessConnections: "ビジネスコネクション",
    friendships: "友情",
    recognition: "認識",
    valueDrivenMembership: "価値駆動型メンバーシップ",
    valueDrivenDesc: "JCI会員は主に個人開発（52%）とインパクトを起こすこと（38%）に動機づけられ、キャリア上の利点は二次的動機です。",
    riseProjects: "RISEプロジェクト",
    peerMentorship: "ピアメンターシップに焦点",
    digitalSkillsWorkshops: "デジタルスキルワークショップ",
    increasingImportance: "重要性が増している",
    keyInsightsTitle: "2025年会員体験調査からの主要インサイト",
    memberPriorities: "会員の優先事項",
    personalGrowthTop: "個人成長がトップモチベーター（28%）",
    leadershipDrives: "リーダーシップ開発がエンゲージメントを促進（24%）",
    strongEmphasis: "ネットワーキングとつながりへの強い重点（21%）",
    commitmentService: "コミュニティサービスへのコミットメントは依然としてコア（17%）",
    valueProposition: "価値提案",
    jciDelivers: "JCIはリーダーシップ開発の期待に応える",
    trainingValued: "トレーニングプログラムは高く評価されている（24%）",
    globalNetworkKey: "グローバルネットワークアクセスは重要な差別化要因",
    tangibleImpact: "会員は具体的なインパクト機会を求める",
    sources: "出典：2025年会員体験調査（3,790人の回答者）• JCIインパクトレポート2025",
    topSkill: "開発すべきトップスキル",
    topSkills: "開発すべきトップスキル",
    rankedByInterest: "会員の関心レベル別ランキング",
    survey2025: "出典：2025年JCI会員体験調査",
    communityBuilding: "コミュニティ構築とサービス",
    priority1: "優先度1",
    publicSpeaking: "パブリックスピーキングとディベートプログラム",
    criticalThinking: "批判的思考と問題解決",
    analysis: "分析と構造化された問題解決",
    leadership: "リーダーシップとチーム構築",
    teamBuilding: "チームリーダーシップとコラボレーションスキル",
    emotionalIntelligence: "感情的知性",
    selfAwareness: "自己認識と対人スキル",
    motivationAnalysis: "モチベーション分析",
    understandingMotivations: "JCI会員のエンゲージメントを促進するものの理解",
    memberExperienceSurvey: "出典：2025年会員体験調査",
    whyMembersJoin: "会員がJCIに参加する理由",
    mostValuedBenefits: "最も価値のあるベネフィット",
    accessToTraining: "トレーニングと認定へのアクセス",
    professionalWorkshops: "プロフェッショナルワークショップとコース",
    globalNetwork: "グローバルネットワークとつながり",
    internationalPartnerships: "国際的パートナーシップとネットワーキング",
    structuredPrograms: "構造化された開発プログラム",
    growthThrough: "経験とプロジェクトを通じた成長",
    topSkillsDevelopment: "開発すべきトップスキル",
    communicationSkills: "コミュニケーションスキル",
    leadershipOpportunities: "リーダーシップ機会",
    accessToRoles: "リーダーシップの役割とポジションへのアクセス",
    professionalNetworking: "プロフェッショナルネットワーキング",
    buildingConnections: "プロフェッショナルなつながりの構築",
    motivationsTitle: "モチベーション分析",
    connectionsAcross: "地域と国を越えたつながり",
    impactOpportunities: "インパクト機会",
    meaningfulChange: "意味のある変化を起こす機会",
    leadershipTitle: "リーダーシップとチーム構築",
    publicSpeakingCompetitions: "パブリックスピーキング競争",
    debatingChampions: "ディベート選手権",
    viewProgramsEvents: "プログラムとイベントを見る",
    priorityNumber: "#1優先度",
    associatedPrograms: "関連プログラム",
    viewPrograms: "プログラムを見る",
    positiveImpact: "コミュニティでポジティブなインパクトを起こす",
    communication: "コミュニケーションとパブリックスピーキング",
    leadershipManagement: "リーダーシップとマネジメント",
    technicalSkills: "技術とデジタルスキル",
    digitalLiteracy: "デジタルリテラシーとテックスキル",
    emerging: "新興",
    publicSpeakingCompetition: "パブリックスピーキング競争",
    participants2024: "52人の参加者（2024年）",
    debatingChampionship: "ディベート選手権",
    participants57: "57チーム（2024年）",
    leadershipTrainingSessions: "リーダーシップトレーニングセッション",
    sessionsDelivered: "2,400以上のセッション実施",
    toypProgram: "TOYPプログラム",
    globalRecognition: "グローバル認識プログラム",
    leadershipWorkshops: "リーダーシップワークショップ",
    globalEventParticipants: "複数のグローバルイベント",
    surveySource: "3,790人の回答者を持つ2025年会員体験調査に基づく",
    skillsSource: "2025年会員体験調査からのスキルデータ",
    motivationsAndBenefits: "会員のモチベーションとベネフィット"
  },
  demographics: {
    title: "会員デモグラフィックス",
    subtitle: "JCI会員の教育、雇用、年齢プロファイルの詳細な内訳",
    averageMemberAge: "平均会員年齢",
    activeMembers: "世界中のアクティブJCI会員",
    yearsOld: "歳",
    educationProfile: "教育プロファイル",
    source: "出典",
    jciMemberSurvey: "2025年JCI会員調査",
    universityEducated: "大学教育",
    highlyEducated: "JCI会員は高度に教育されたプロフェッショナル",
    employmentStatus: "雇用状況",
    sourceCitation: "出典：2025年JCI会員調査 - 公式デモグラフィックデータ"
  },
  globalMemberProfile: {
    title: "グローバル会員プロファイル",
    surveyDescription: "2025年会員体験調査 • 3,790人の回答者",
    educationalAttainment: "教育達成度",
    employmentDistribution: "雇用分布",
    industryDiversity: "業界の多様性",
    keyInsight: "JCI会員の97%以上が大学学位を取得または取得中",
    entrepreneursInsight: "31%が起業家または自営業",
    primarySectors: "JCI会員が代表する主要セクター",
    sourceCitation: "出典：JCI会員データ2025 | JCIインパクトレポート2025 | 2025年会員体験調査"
  },
  memberExperience: {
    title: "会員体験ダッシュボード",
    subtitle: "会員満足度とエンゲージメントメトリクス",
    netPromoterScore: "ネットプロモータースコア",
    npsBreakdown: "NPSブレークダウン",
    memberSatisfaction: "会員満足度",
    promoters: "推奨者",
    neutrals: "中立",
    detractors: "批判者"
  },
  alumniNetwork: {
    title: "アラムナイネットワーク",
    subtitle: "JCIアラムナイグローバルネットワーク - アクティブメンバーシップを超えたインパクト",
    totalAlumni: "総アラムナイ",
    totalAlumniDesc: "JCIアラムナイのグローバルネットワーク",
    remainingActive: "アクティブアラムナイ",
    remainingActiveDesc: "JCI後もある程度の関与を維持",
    leadershipPositions: "リーダーシップポジション",
    leadershipPositionsDesc: "企業、政府、非営利のリーダーシップ",
    businessOwners: "ビジネスオーナー",
    businessOwnersDesc: "ビジネスを開始または継承"
  },
  eventPreferences: {
    title: "イベントの好み",
    subtitle: "会員が最も価値を置くイベントタイプ",
    networking: "ネットワーキングイベント",
    training: "トレーニングワークショップ",
    conferences: "カンファレンス",
    community: "コミュニティプロジェクト",
    social: "ソーシャルイベント"
  },
  occupationIndustry: {
    title: "職業と業界",
    subtitle: "会員の職業分布と業界セクター",
    topOccupations: "トップ職業",
    topIndustries: "トップ業界",
    entrepreneur: "起業家/自営業",
    manager: "マネージャー/ディレクター",
    professional: "プロフェッショナル",
    consultant: "コンサルタント",
    executive: "エグゼクティブ",
    techIt: "テクノロジー/IT",
    finance: "ファイナンス/バンキング",
    manufacturing: "製造/工業",
    healthcare: "ヘルスケア",
    consulting: "コンサルティング"
  },
  skillsDevelopment: {
    title: "スキル開発ダッシュボード",
    headline: "年間1,969人以上のリーダーを育成",
    heroDescription: "リーダーの育成はJCIのミッションの中心にあります。2024-2025年、JCIは4つの機会分野でワールドクラスのトレーニングを提供し、約2,000人のメンバーにリーダーシップ、コミュニケーション、起業家精神、市民責任の実践的スキルを提供しました。",
    totalParticipants: "トレーニングを受けた総参加者",
    members: "メンバー",
    leadershipSessions: "リーダーシップトレーニングセッション",
    globally: "グローバルに",
    skillsSessions: "スキル開発セッション",
    totalSessions: "総セッション",
    certifiedTrainers: "認定トレーナーネットワーク",
    activeTrainers: "アクティブトレーナー",
    certifiedTrainersByRegion: "地域別認定トレーナー",
    region: "地域",
    trainers: "認定トレーナー",
    percentGlobal: "グローバルの%",
    trainingMultiplier: "トレーニング乗数",
    asiaPacific: "アジアと太平洋",
    africaMiddleEast: "アフリカ・中東",
    americas: "アメリカ",
    europe: "ヨーロッパ",
    highestCapacity: "最高の能力",
    rapidGrowth: "急速な成長",
    establishedNetwork: "確立されたネットワーク",
    steadyPresence: "安定した存在",
    cascadingKnowledge: "各トレーナーは5-10人の追加トレーナーを認定できます",
    specializedTracks: "専門トレーニングトラック",
    publicSpeakingTrack: "パブリックスピーキング＆コミュニケーション",
    debatingTrack: "ディベート＆クリティカルシンキング",
    trainerCertification: "トレーナー認定プログラム",
    conferenceTraining: "カンファレンス別トレーニング深度（2025年）",
    conference: "カンファレンス",
    location: "場所",
    participants: "参加者",
    sessions: "セッション",
    regionalReach: "地域リーチ",
    skillsCategories: "カバーされるスキルカテゴリー",
    leadershipDecision: "リーダーシップ＆意思決定",
    communicationInfluence: "コミュニケーション＆影響力",
    entrepreneurshipInnovation: "起業家精神＆イノベーション",
    projectManagement: "プロジェクト管理＆実行",
    civicResponsibility: "市民責任＆グローバルシチズンシップ",
    memberProgression: "メンバー進行パスウェイ",
    stage1: "ステージ1：参加者",
    stage2: "ステージ2：実践者",
    stage3: "ステージ3：認定トレーナー",
    stage4: "ステージ4：マスタートレーナー/メンター",
    ctaTitle: "リーダーシップジャーニーに投資",
    exploreTrainings: "利用可能なトレーニングを探す",
    becomeCertified: "認定トレーナーになる",
    sourceNote: "出典：JCIインパクトレポート2025 – スキル開発データ"
  },
  jciFoundation: {
    title: "JCI財団グラントプログラム",
    headline: "年間$100K以上：メンバーイノベーションへの資金提供",
    heroDescription: "JCI財団は資金調達以上のものを表しています—それはリーダーシップの機会を民主化し、素晴らしいアイデアが予算の制約によって制限されないことを保証するコミットメントです。",
    grantsOverTime: "財団グラントの推移",
    year: "年",
    totalAwarded: "授与されたグラント総額（USD）",
    trend: "トレンド",
    interpretation: "解釈",
    highInvestment: "高投資年",
    consolidation: "統合フェーズ",
    focusOnImpact: "ボリュームよりインパクトに焦点",
    threeYearTotal: "3年間合計：$405,000がJCIメンバーイニシアチブに投資",
    whatGrantsFund: "グラントが資金提供するもの（2024-2025）",
    programsCompetitions: "JCIプログラムコンペティション",
    leadershipAcademies: "リーダーシップアカデミー＆サミット",
    entrepreneurshipSupport: "起業家精神＆ビジネスサポート",
    infrastructureSupport: "物理的事務局＆インフラ",
    growthInitiatives: "成長＆開発イニシアチブ",
    regionalAllocation: "地域別配分",
    successStories: "財団グラントの成功事例",
    grantCycle: "グラントサイクルプロセス",
    ctaTitle: "JCIイニシアチブに資金を",
    viewOpportunities: "グラント機会を見る",
    checkQualify: "資格を確認",
    submitProposal: "提案を提出",
    sourceNote: "出典：JCI財団年次報告書2025"
  },
  jciSenate: {
    title: "JCIセネート認定",
    headline: "84,375人の生涯リーダー：JCIセネート",
    heroDescription: "JCIセネートは名誉以上のものです—それは卓越したリーダーのグローバルコミュニティへの生涯メンバーシップです。",
    totalSenators: "アクティブセネター総数",
    allTime: "全期間",
    newSenators: "2025年に表彰されたセネター",
    newSelections: "新規選出",
    annualGrowth: "年間成長率",
    sustainableGrowth: "持続可能、品質重視",
    lifetimeValue: "生涯価値",
    unlimitedMentorship: "無制限のメンターシップ、ネットワーキング、エンゲージメント",
    demographicsDashboard: "セネターの人口統計",
    ageProfile: "年齢プロファイル",
    genderComposition: "ジェンダー構成",
    male: "男性",
    female: "女性",
    professionalBackground: "プロフェッショナルバックグラウンド",
    corporateExecutives: "企業エグゼクティブ",
    entrepreneursOwners: "起業家/ビジネスオーナー",
    educatorsTrainers: "教育者＆トレーナー",
    governmentPublic: "政府＆公共セクター",
    nonprofitSocial: "非営利＆ソーシャルセクター",
    otherFields: "その他の専門分野",
    valueProposition: "セネートの価値提案",
    engagementTiers: "セネートエンゲージメントモデル",
    tier1: "ティア1：メンターシップ",
    tier2: "ティア2：プログラムリーダーシップ",
    tier3: "ティア3：組織リーダーシップ",
    tier4: "ティア4：レガシー＆アドボカシー",
    successMetrics: "セネート成功メトリクス",
    ctaTitle: "JCIセネートに参加",
    understandPath: "セネターシップパスを理解",
    exploreBenefits: "セネターベネフィットを探る",
    becomeMentor: "メンターになる",
    nominateLeaders: "卓越したリーダーを推薦",
    sourceNote: "出典：JCIセネートレジストリ2025"
  }
} as const;

